<div *ngIf="message$ | async as message" class="text-reduced-medium announcment-bar-container p-2">
  <div class="container inner-container d-flex align-items-center justify-content-center">
    <span class="exclamation-symbol">
      <svg-icon key="exclamation-mark"></svg-icon>
    </span>
    <div [innerHTML]="message"></div>
    <svg-icon (click)="onCloseClicked()" key="close" class="close-btn"></svg-icon>
  </div>
</div>
